
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.993 12.49l-3.301 1.908a.8.8 0 01-1.18-.871l.833-3.639L1.46 7.241c-.535-.49-.191-1.384.535-1.39l3.824-.027L7.25 2.011c.262-.696 1.248-.69 1.501.009l1.384 3.813 3.868.019c.73.003 1.074.902.533 1.392L11.61 9.897l.875 3.62a.8.8 0 01-1.177.882L7.993 12.49zm-.4-1.616a.8.8 0 01.799 0l2.101 1.209-.549-2.272a.8.8 0 01.24-.78l1.753-1.59-2.367-.01a.8.8 0 01-.748-.528l-.835-2.302-.865 2.3a.8.8 0 01-.743.52l-2.34.016 1.73 1.587a.8.8 0 01.24.768l-.528 2.302 2.111-1.22z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    